<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="firstcenter"></p>
<p class="firstcenter"></p>
<p class="firstcenter"><strong class="b">Dedication (from Paul Copan)</strong></p>
<p class="firstcenter"><em class="i">To my loving wife, Jacqueline,</em></p>
<p class="firstcenter"><em class="i">whose gentle and wise spirit radiates</em></p>
<p class="firstcenter"><em class="i">the glory and presence of God</em></p>
<p class="firstcenter"><em class="i">and is a daily encouragement and inspiration</em></p>
<p class="firstcenter"><em class="i">to me and our children.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5760b79c